export default __webpack_public_path__ + "static/media/logo.2eabc25c.webp";